import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimpleAddressPipe } from './simple-address.pipe';

@NgModule({
  declarations: [SimpleAddressPipe],
  imports: [CommonModule],
  exports: [SimpleAddressPipe],
})
export class SimpleAddressPipeModule {}
